// import Plyr from "plyr-react"
// import "plyr-react/plyr.css"
// import React, {useEffect,useRef,Component,createRef} from "react";

// Class base component
// const Plyr_online_Component = () => {
//     const ref = useRef()
//
//     useEffect(() => {
//         console.log("internal plyr instance:", ref.current.plyr)
//     })
//
//     return <Plyr ref={ref} />
// }

// Class base component
// class Plyr_online_Component extends Component {
//     constructor(props) {
//         super(props)
//         this.player = createRef()
//     }
//
//     componentDidMount() {
//         console.log("internal plyr instance", this.player.current.plyr)
//     }
//
//     render() {
//         return <Plyr ref={(player) => (this.player.current = player)} />
//     }
// }


/////Function base component
// const Plyr_online_Component = () => {
//     const ref = useRef()
//
//     useEffect(() => {
//         console.log("internal plyr instance:", ref.current.plyr)
//     });
//
//
//
//     return <Plyr ref={ref} />
//
// }



import Plyr from "plyr-react";
import "plyr-react/plyr.css";

// const videoId = "yWtFb9LJs3o";
// const provider = "youtube";


////const videoId = "https://shahrameslami.ir/Bfaryad/rrr/r222-HD.mp4";
const videoId = "";
const provider = "html5";
///const provider = "youtube";


const videoOptions = undefined;

const Plyr_online_Component = (props) => {
    ///const ref = useRef<APITypes>(null);

    // const enterVideo = () => {
    //    /// (ref.current?.plyr as Plyr)?.fullscreen.enter();
    // };

    // const make2x = () => {
    //     const plyrInstance = ref.current?.plyr as Plyr;
    //     if (plyrInstance) plyrInstance.speed = 2;
    // };

    const plyrVideo =
        props.src_video && provider ? (
            <Plyr
               /// ref={ref}
                source={{
                    type: "video",
                    sources: [
                        {
                            src: props.src_video,
                            provider: provider
                        }
                    ]
                }}

                options={videoOptions}
            />
        ) : null;

    return (
        <div>
            {plyrVideo}
            {/*<button onClick={enterVideo}>fullscreen</button>*/}
            {/*<button onClick={make2x}>2x</button>*/}
        </div>
    );
};

export default Plyr_online_Component;

